<template>
  <IonToolbar color="white">
    <HeaderBackButton @click.stop="goBackToPropertyDetails">{{ selectedProperty.property?.name }} </HeaderBackButton>
  </IonToolbar>
  <IonToolbar color="white" class="border-b-2 border-gray-300">
    <div class="text-2xl text-gray-900 font-bold flex items-center">
      <i class="icon-repeater text-green-700 mr-2"></i>
      <div class="flex-1">Network</div>
    </div>
    <IonButtons slot="end">
      <AddRepeaterModal></AddRepeaterModal>
    </IonButtons>
  </IonToolbar>
</template>

<script setup lang="ts">
import HeaderBackButton from '@/components/forms/HeaderBackButton.vue';
import { useSelectedProperty } from '@/stores/selected-property.store';
import { IonButtons, IonToolbar, useIonRouter } from '@ionic/vue';
import AddRepeaterModal from '../network/AddRepeaterModal.vue';

const router = useIonRouter();
const selectedProperty = useSelectedProperty();

function goBackToPropertyDetails() {
  return router.navigate(`/property/${selectedProperty.propertyId}`, 'back', 'push');
}
</script>

<style scoped></style>
